import Vue from 'vue'
import Vuex from 'vuex'
import Moment from 'moment'
import actions from '@/store/actions'
import mutations from '@/store/mutations'
import config from '@/utils/const'

Vue.use(Vuex)

Moment.defineLocale('ja', {
  weekdays: ['日曜日', '月曜日', '火曜日', '水曜日', '木曜日', '金曜日', '土曜日'],
  weekdaysShort: ['日', '月', '火', '水', '木', '金', '土']
})

export default new Vuex.Store({
  strict: process.env.NODE_ENV !== 'production',
  state: {
    /**
     * サインインユーザーの情報
     * @type {Object}
     */
    currentUser: {},
    /**
     * サインインユーザーの所属テナント
     * @type {String}
     */
    tenant: '',
    /**
     * サインイン中かを判別するフラグ
     * @type {Boolean}
     */
    isSignIn: false,
    /**
     * 読み込み中かを判別するフラグ
     * @type {Boolean}
     */
    isLoading: false,
    /**
     * グループ選択エリア表示中かを判別するフラグ
     * @type {Boolean}
     */
    isShowMenu: !localStorage.getItem('isShowMenu') ? false : localStorage.getItem('isShowMenu').toLowerCase() === 'true',
    /**
     * 今日の日付
     * @type {Moment}
     */
    today: Moment(),
    /**
     * 月、日、人、フォーム画面で参照される日付
     * @type {Moment}
     */
    thisDate: Moment(),
    /**
     * グループ情報の連想配列
     * @type {Object}
     */
    groups: {
      /**
       * グループ情報
       * @type {Array}
       */
      data: [],
      /**
       * グループ情報取得時のエラー判定
       * @type {Boolean}
       */
      error: false
    },
    /**
     * グループにユーザがいないかどうか
     * @type {Boolean}
     */
    isNoUsersInSelectedGroup: false,
    /**
     * グループが存在するか判別するフラグ
     * @type {Boolean}
     */
    existsGroup: false,
    /**
     * リレーションが存在するか判別するフラグ
     * @type {Boolean}
     */
    existsRelation: false,
    /**
     * 選択中のグループID
     * @type {String}
     */
    selectedGroupId: '',
    /**
     * ユーザーの情報を格納
     * @type {Object}
     *   <変数名>   <データ型>     <例>        <説明>
     *  id         : String : 'Zjia3wr9ur' : ユーザーID
     *  mail       : String : 'xxx@ab.com' : メールアドレス
     *  priority   : Number : 1            : ユーザーの表示順(昇順)
     *  name.last  : String : '佐藤'       : ユーザーの姓
     *  name.first : String : '太郎'       : ユーザーの名
     */
    users: {
      /**
       * ユーザー情報
       * @type {Array}
       */
      data: [],
      /**
       * ユーザー情報取得時のエラー判定
       * @type {Boolean}
       */
      error: false
    },
    /**
     * フォーム画面や人画面で表示させるユーザーのID
     * @type {String}
     */
    selectedUserId: '',
    /**
     * 月画面や日画面で表示させるユーザーのID
     * @type {Array}
     */
    selectedUsers: [],
    /**
     * ユーザーIDとした日報データ
     * @type {Object}
     *  <変数名>     <データ型>     <例>         <説明>
     *  date        : String : '2020-07-21' : 投稿された日付[YYYY-MM-DD]
     *  time        : Number : '8'          : 勤務時間
     *  displayTime : String : '8h20m'      : 勤務時間（表示用）
     *  feel        : String : 'mood'       : 今日の気分(5段階)
     *  actual      : String : '...'        : 今日の実績
     *  summary     : String : '...'        : 総括
     *  note        : String : '...'        : 特記事項
     *  plan        : String : '...'        : 次営業日の予定
     *  event       : String : '...'        : 直近の予定
     */
    diaries: {
      /**
       * 日報情報
       * @type {Array}
       */
      data: [],
      /**
       * 日報情報取得時のエラー判定
       * @type {Boolean}
       */
      error: false
    },
    /**
     * 現在編集中かどうか
     * @type {Boolean}
     */
    hasChanged: false,
    /**
     * インポートの状態 { run: 実行状態, user: 実行してるユーザー }
     * @type {Object}
     */
    import: {
      run: config.import.run.none,
      user: ''
    },
    /**
     * Teams投稿用メールアドレス
     * @type {String}
     */
    teamsMailAddress: '',
    /**
     * 勤怠連絡先メールアドレス
     * @type {String}
     */
    workMailAddress: ''
  },
  actions,
  mutations
})



// WEBPACK FOOTER //
// ./src/store/index.js